/** 机器人 / 转发任务：站点树形展示（与站点管理、小程序目录一致） */

import { buildSiteHierarchyDisplayRows, type SiteHierarchyDisplayRow, type SiteTreeMeta } from '@/lib/catalogSiteTree';

export type RobotSiteRow = SiteTreeMeta & {
  site_code: string;
  enabled?: boolean;
};

export type RobotSiteDisplayRow = SiteHierarchyDisplayRow<RobotSiteRow>;

export function buildRobotSiteDisplayRows(sites: RobotSiteRow[]): RobotSiteDisplayRow[] {
  return buildSiteHierarchyDisplayRows(sites);
}
